module.exports = __webpack_public_path__ + "media/team/Cody-af255771.png";